import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import Home from './pages/Home';
import Sorgvejleder from './pages/Sorgvejleder';
import Dodsdoula from './pages/Dodsdoula';
import About from './pages/About';
// import Podcast from './pages/Podcast'; // Skjult - Podcast.jsx er bevaret til senere genaktivering
import Contact from './pages/Contact';
import ForedragWorkshops from './pages/ForedragWorkshops';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sorgvejleder" element={<Sorgvejleder />} />
        <Route path="/dodsdoula" element={<Dodsdoula />} />
        <Route path="/foredrag-workshops" element={<ForedragWorkshops />} />
        <Route path="/om-asha" element={<About />} />
        {/* Podcast er skjult: omdiriger til forsiden hvis nogen tilgår URL'en direkte */}
        <Route path="/podcast" element={<Navigate to="/" replace />} />
        <Route path="/kontakt" element={<Contact />} />
      </Routes>
    </Layout>
  );
}

export default App;
